import apiClient from './apiClient';
import type { ApiResponse } from '../types/api';

export interface MedicalHistoryType {
  id: number;
  name: string;
  code: string;
  description: string;
  category: 'personal' | 'familiar' | 'surgical' | 'allergic' | 'vaccination' | 'obstetric';
  is_active: boolean;
}

export interface PatientMedicalHistory {
  id: number;
  patient_id: number;
  history_type_id: number;
  description: string;
  onset_date: string | null;
  end_date: string | null;
  is_active: boolean;
  notes: string | null;
  history_type?: MedicalHistoryType;
}

export const medicalHistoryTypeService = {
  async getAll(): Promise<MedicalHistoryType[]> {
    const response = await apiClient.get<{ data: MedicalHistoryType[] }>('/medical-history-types', {
      params: { per_page: 100 },
    });
    return response.data.data || [];
  },

  async getByCategory(category: string): Promise<MedicalHistoryType[]> {
    const all = await this.getAll();
    return all.filter(t => t.category === category && t.is_active);
  },
};

export const patientMedicalHistoryService = {
  async getByPatient(patientId: number): Promise<PatientMedicalHistory[]> {
    const response = await apiClient.get<ApiResponse<PatientMedicalHistory[]>>(
      `/patient-medical-histories/patient/${patientId}`
    );
    return response.data.data || [];
  },

  async create(data: {
    patient_id: number;
    history_type_id: number;
    description: string;
    onset_date?: string;
    end_date?: string;
    notes?: string;
  }): Promise<PatientMedicalHistory> {
    const response = await apiClient.post<ApiResponse<PatientMedicalHistory>>('/patient-medical-histories', data);
    return response.data.data;
  },

  async update(id: number, data: Partial<{
    history_type_id: number;
    description: string;
    onset_date: string;
    end_date: string;
    notes: string;
    is_active: boolean;
  }>): Promise<PatientMedicalHistory> {
    const response = await apiClient.put<ApiResponse<PatientMedicalHistory>>(`/patient-medical-histories/${id}`, data);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/patient-medical-histories/${id}`);
  },
};
